import React from 'react'
import { KsError, Resolution } from '../../EntryListItem/Entry'
import { ProtocolInterface } from '../../UI/Protocol/Protocol'
import { Box } from '@mui/material'
import { TrafficWebSocketStreamingOption } from '../../Filters/WebsocketOptionsDropdown'
import { NamespaceBadge } from './NamespaceBadge'
import { EntryDestination, EntrySource } from '../../../types/trafficEntry'
import { GenericDirectionIcon } from '../../EntryListItem/icons/GenericDirectionIcon'
import variables from '../../../variables.module.scss'

interface NamespacesProps {
  headingMode: boolean
  entryDetailsOpen: boolean
  windowWidth: number
  wsOption: unknown
  src: Resolution
  error: KsError
  proto: ProtocolInterface
  dst: Resolution
  tooltipInverted?: boolean
}

export const Namespaces: React.FC<NamespacesProps> = (props)=> {
  return (
    <Box display='flex' alignItems='center' gap='5px'>
      {(props.headingMode ||
        !props.entryDetailsOpen ||
        props.windowWidth >= 2300 ||
        props.wsOption === TrafficWebSocketStreamingOption.FlowsOnly) && (
        <>
          <NamespaceBadge
            namespace={props.src.namespace}
            point={EntrySource}
            color={props.src?.namespaceColorSet?.color}
            resolutionMechanism={props.src.resolutionMechanism}
            tooltipInverted={props?.tooltipInverted}
          />
          <GenericDirectionIcon
            fill={
              props.error ? variables.failureColor : props.proto.backgroundColor
            }
          />
        </>
      )}
      {(props.headingMode ||
        !props.entryDetailsOpen ||
        props.windowWidth >= 1200) && (
        <NamespaceBadge
          namespace={props.dst.namespace}
          point={EntryDestination}
          color={props.dst?.namespaceColorSet?.color}
          resolutionMechanism={props.dst.resolutionMechanism}
          tooltipInverted={props?.tooltipInverted}
        />
      )}
    </Box>
  )
}
